'use strict';

var Backbone = require('backbone');
var _ = require('underscore');

var stripe = require('../utilities/stripe').default;
var polyglot = require('../utilities/polyglot').default;

export default Backbone.Model.extend({

  validate: function (attrs, options) {
    var errors = {};
    if (!stripe.card.validateCardNumber(attrs.number)) {
      errors.number = polyglot.t('forms.number.error');
    }

    if (!stripe.card.validateExpiry(attrs.exp_month, attrs.exp_year)) {
      errors.exp = polyglot.t('forms.exp.error');
    }

    if (!attrs.name) {
      errors.name = polyglot.t('forms.name.error');
    }

    if (!stripe.card.validateCVC(attrs.cvc)) {
      errors.cvc = polyglot.t('forms.cvc.error');
    }

    if (_.size(errors)) {
      return errors;
    }
  },

});
